module.exports = __webpack_public_path__ + "static/TT-Testfit_Floor28-034e14010ce4154a54b3932a4b73768c.pdf";